const CloudContext = require('./cloud-context');

module.exports = CloudContext();


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-cloud-core/lib/cloud-context-singleton.js